export default "__VITE_ASSET__BYtf3JZr__"